export default __webpack_public_path__ + "static/media/add.00d70961.svg";